module.exports = __webpack_public_path__ + "img/tob_3.341ff009.png";